'use strict';

module.exports = function htmlToMindmupArray(htmlText) {
	if (!htmlText) {
		return;
	}
	const lastNodesByLevel = [],
		ideaArray = [],
		parseHtml = (htmlText) => {
			const parser = new DOMParser();
			try {
				return parser.parseFromString(htmlText, 'text/html');
			} catch (e) {
				return false;
			}
		},
		directChildren = function (node, tagNames) {
			if (!node.children) {
				return [];
			}
			return Array.from(node.children).filter(t => t.tagName && tagNames.includes(t.tagName.toUpperCase()));
		},
		findParent = (level) => {
			const potential = lastNodesByLevel.slice(0, level);
			return potential.reverse().find(item => item);
		},
		pushIdea = (level, text) => {
			const ideaToPush = {title: text},
				parent = findParent(level);
			if (!level || !parent) {
				ideaArray.push(ideaToPush);
			} else {
				parent.ideas = parent.ideas || {};
				parent.ideas[Object.keys(parent.ideas).length + 1] = ideaToPush;
			}
			lastNodesByLevel[level] = ideaToPush;
		},
		sanitize = function (content) {
			if (!content) {
				return '';
			}
			return content.trim().replace(/\t+/g, ' ');
		},
		pushCell = function (tableCellElement, cellIndex) {
			const content = sanitize(tableCellElement.textContent);
			if (content) {
				pushIdea(cellIndex, content);
			}
		},
		pushRow = function (tableRowElement) {
			Array.from(tableRowElement.querySelectorAll('td')).forEach(pushCell);
		},
		pushTable = function (tableElement) {
			Array.from(tableElement.querySelectorAll('tr')).forEach(pushRow);
		},
		pushListElement = function (listElement, level) {
			const subLists = directChildren(listElement, ['UL', 'OL']),
				remappedChildReferences = subLists.map(sub => listElement.removeChild(sub));
			pushCell(listElement, level);
			remappedChildReferences.forEach(sub => pushList(sub, level + 1)); //eslint-disable-line no-use-before-define
		},
		pushList = function (listElement, level) {
			directChildren(listElement, ['LI', 'UL', 'OL']).forEach(e => {
				if (e.tagName.toUpperCase() === 'LI') {
					pushListElement(e, level);
				} else {
					pushList(e, level + 1);
				}
			});
		},
		doc = parseHtml(htmlText);

	if (!doc) {
		return false;
	}
	Array.from(doc.querySelectorAll('table')).forEach(pushTable);
	Array.from(doc.querySelectorAll(':not(li):not(ul):not(ol) > ul, :not(li):not(ul):not(ol) > ol')).forEach(e => pushList(e, 0));
	return ideaArray.length && ideaArray;
};
